import { Col, Container, Row } from "react-bootstrap";
import PdfJobs from "@components/PdfJobs/PdfJobs";
import { loadPdfJobs } from "@store/actions";
import { getLoadingStatus, getPagination, getPdfJobs } from "@store/selectors/pdf";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import Select from "@components/Select/Select";
import clx from "classnames";
import ReactPaginate from "react-paginate";
const styles = require("./styles.scss");
const MainPage = () => {
    const dispatch = useDispatch();
    const isLoadingJobs = useSelector(getLoadingStatus);
    const jobs = useSelector(getPdfJobs);
    const pagination = useSelector(getPagination);
    useEffect(() => {
        async function fetchData() {
            await dispatch(loadPdfJobs({ PageNumber: 1 }));
        }
        fetchData();
    }, []);
    return (React.createElement(Container, null,
        React.createElement(Row, null,
            React.createElement(Col, null,
                React.createElement(PdfJobs, { jobs: jobs, isLoading: isLoadingJobs }))),
        React.createElement(Row, null,
            React.createElement(Col, { className: clx(styles.tableFooter) },
                React.createElement("div", { className: "float-left" },
                    React.createElement(ReactPaginate, { pageCount: pagination.totalPages, pageRangeDisplayed: 5, marginPagesDisplayed: 2, containerClassName: "pagination", activeClassName: "active", pageClassName: "page-item", pageLinkClassName: "page-link", breakClassName: "page-item disabled", breakLinkClassName: "page-link", previousLabel: "‹", nextLabel: "›", previousClassName: "page-item", nextClassName: "page-item", previousLinkClassName: "page-link", nextLinkClassName: "page-link", onPageChange: e => {
                            dispatch(loadPdfJobs({ PageNumber: e.selected + 1 }));
                        } })),
                React.createElement("div", { className: "float-right" },
                    React.createElement(Select, { onChange: params => dispatch(loadPdfJobs(params)), selectOptions: [5, 10, 25, 50] }))))));
};
export default MainPage;
